import { Button, Box, Flex, TextInput, Text, Anchor } from '@mantine/core';
import { useForm } from '@mantine/form';
import classes from './recoverPassword.module.scss';
import { IconMail } from '@tabler/icons-react';
import { Link } from 'react-router';
import { zodResolver } from 'mantine-form-zod-resolver';
import { VALIDATE_SCHEMA } from './types';
import { useRecoverPassword } from '@entities/auth/api/hooks/mutations';
import { showNotification } from '@shared/utils';

export const RecoverPassword = () => {
  const {
    mutate: mutateRecoverPassword,
    isPending,
    isSuccess,
  } = useRecoverPassword();

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      email: '',
    },
    validate: zodResolver(VALIDATE_SCHEMA),
  });

  const handleSubmit = (values: typeof form.values) => {
    mutateRecoverPassword(values, {
      onError: error => {
        showNotification({
          error,
          variant: 'error',
          message:
            error?.response?.data?.message || 'Ошибка при отправке запроса',
        });
      },
    });
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Box>
        <Flex>
          <Text component='label' htmlFor='email' className={classes.label}>
            Email
          </Text>
        </Flex>
        <TextInput
          {...form.getInputProps('email')}
          key={form.key('email')}
          placeholder='your@email.com'
          withAsterisk
          w='100%'
          leftSection={
            <Box px='0.3rem' pt='0.3rem'>
              <IconMail color='var(--mantine-color-primary-4)' size={20} />
            </Box>
          }
          error={form.errors.email}
          radius='0.75rem'
        />
      </Box>

      <Button
        type='submit'
        variant='primary'
        mt='2rem'
        mb='1.5rem'
        fullWidth
        className={classes.recoverButton}
        loading={isPending}
        disabled={isPending || isSuccess}
      >
        Восстановить
      </Button>

      <Flex gap={8}>
        <Text c='tertiary.7'>Вспомнили пароль?</Text>
        <Anchor className={classes.anchor} component={Link} to='/auth'>
          Вернуться назад
        </Anchor>
      </Flex>
    </form>
  );
};
